// get all
export const FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS =
  'FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS';
export const GET_LIQUIDATION_DIFFERENCE_REASONS =
  'GET_LIQUIDATION_DIFFERENCE_REASONS';
export const CLEAR_LIQUIDATION_DIFFERENCE_REASONS =
  'CLEAR_LIQUIDATION_DIFFERENCE_REASONS';
export const FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON =
  'FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON';
export const GET_LIQUIDATION_DIFFERENCE_REASON =
  'GET_LIQUIDATION_DIFFERENCE_REASON';
export const CLEAR_LIQUIDATION_DIFFERENCE_REASON =
  'CLEAR_LIQUIDATION_DIFFERENCE_REASON';
